// extracted by mini-css-extract-plugin
module.exports = {"content":"BannerFullWidth_content__au9_V","btn":"BannerFullWidth_btn__zKnWz"};